import { CustomLabel } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  ${CustomLabel} {
    display: block;
  }
  @media (max-width: 1300px) {
    .copy-button-with-icon {
      gap: 5px;
      width: 220px;
      max-width: unset;
      label {
        font-size: 14px;
      }
    }
  }
`;
